import { formatDate } from '@/utils/dateUtils'

// 格式化金额
export const formatCurrency = (value) => {
  if (!value) return '0.00'
  return Number(value).toLocaleString('zh-CN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })
}

// 格式化联营类型
export const formatJointType = (type) => {
  const typeMap = { '1': '固定本息', '2': '固定收益', '3': '固定时长' }
  return typeMap[type] || type
}

// 格式化联营状态
export const formatStatus = (status) => {
  const statusMap = {
    '1': '联营中',
    '2': '正常联营结束',
    '3': '投后风险处理中',
    '4': '提前回购'
  }
  return statusMap[status] || status
}

// 状态 → 语义标签样式（设计系统 token）
export const statusTagClass = (status) => {
  const map = {
    '1': 'tag-success',
    '2': 'tag-neutral',
    '3': 'tag-warning',
    '4': 'tag-info'
  }
  return map[status] || 'tag-neutral'
}

// 格式化注册资本
export const formatCapital = (companyInfo) => {
  if (!companyInfo) return '-'
  const { registered_capital, registered_capital_unit, registered_capital_ccy } = companyInfo
  if (!registered_capital) return '-'
  let capitalStr = registered_capital
  if (registered_capital_unit) capitalStr += registered_capital_unit
  if (registered_capital_ccy && registered_capital_ccy !== 'CNY') capitalStr += `(${registered_capital_ccy})`
  return capitalStr
}

// 通用：无值显示占位
export const dash = (v) => (v === null || v === undefined || v === '' ? '—' : v)

export { formatDate }
